import Keycloak, { KeycloakInitOptions } from 'keycloak-js';

const url =
  process.env.REACT_APP_KEYCLOAK_URL ?? 'https://auth.geowellex.com/auth';
const realm = process.env.REACT_APP_KEYCLOAK_REALM ?? 'Geowellex';
const clientId =
  process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? 'geowellex-scal';

export const keycloak = new Keycloak({ url, realm, clientId });

export const keycloakInitOptions: KeycloakInitOptions = {
  onLoad: 'check-sso',
  checkLoginIframe: false
};

export const TOKEN_REFRESH_INTERVAL_MS = 60_000;
export const TOKEN_MIN_VALIDITY_SECONDS = 60;
